import React, { useContext } from "react";
import "./style.css";
import workshops from "../../util/workshops.json";
import { useEffect } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import { User, FileText, BookOpen } from "lucide-react";

function Summary() {
  const { data } = useContext(RegistrationContext);

  useEffect(() => {
    window.history.replaceState({}, "", "/");
  }, []);

  const workshop_selection_ids = data.workshop_selection;
  const selected_workshops_list = [];
  workshops.forEach((workshop) => {
    if (workshop_selection_ids && workshop_selection_ids.includes(workshop.id)) {
      selected_workshops_list.push(workshop);
    }
  });

  const hasPapers = data.papers_registered && data.papers_registered.length > 0;
  const hasWorkshops = selected_workshops_list.length > 0;

  return (
    <div className="flex flex-col gap-6">

      {/* Delegate info card */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100" style={{ background: "#f8faff" }}>
          <User size={18} color="#002E78" />
          <span className="font-semibold text-[#002E78]">Delegate Information</span>
        </div>
        <div className="divide-y divide-gray-50">
          <Row label="Registration type" value={data.type} />
          <Row label="Full name" value={data.full_name} />
          {data.affiliation && (
            <Row label="Affiliation" value={data.affiliation.split("\n").filter(Boolean).join(" · ")} />
          )}
        </div>
      </div>

      {/* Papers card */}
      {hasPapers && (
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100" style={{ background: "#f8faff" }}>
            <FileText size={18} color="#002E78" />
            <span className="font-semibold text-[#002E78]">Registered Papers</span>
          </div>
          <ul className="divide-y divide-gray-50">
            {data.papers_registered.map((paper, index) => (
              <li key={index} className="flex items-start gap-3 px-6 py-4">
                <span
                  className="shrink-0 mt-0.5 text-xs font-bold text-white px-2 py-0.5 rounded"
                  style={{ background: index === 0 ? "#002E78" : "#64748b" }}
                >
                  {index === 0 ? "FREE" : "PAID"}
                </span>
                <span className="text-gray-800 text-sm">{paper}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Workshops card */}
      {hasWorkshops && (
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100" style={{ background: "#f8faff" }}>
            <BookOpen size={18} color="#002E78" />
            <span className="font-semibold text-[#002E78]">Workshop Preferences</span>
          </div>
          <ul className="divide-y divide-gray-50">
            {selected_workshops_list.map((workshop, index) => (
              <li key={index} className="flex items-center gap-3 px-6 py-4">
                <span className="text-xs font-semibold text-[#002E78] bg-blue-50 rounded-full w-6 h-6 flex items-center justify-center shrink-0">
                  {index + 1}
                </span>
                <span className="text-gray-800 text-sm">{workshop.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center px-6 py-4 gap-1">
      <span className="text-xs font-semibold uppercase tracking-wide text-gray-400 sm:w-44 shrink-0">{label}</span>
      <span className="text-gray-800 text-sm font-medium">{value}</span>
    </div>
  );
}

export default Summary;
